import axios from 'axios';

const API_BASE = process.env.REACT_APP_API_CONNECT;

const myAPI = axios.create({
    // withCredentials: true
})

myAPI.interceptors.request.use((config) => {
    config.headers.Authorization = `Bearer ${localStorage.getItem('token')}`;
    return config
})

export const API = {
    getAllMusic: () => myAPI.get(`${API_BASE}/music`),
    deleteMusic: (id) => myAPI.delete(`${API_BASE}/music/${id}`),
    addMusic: (formData) => myAPI.post(`${API_BASE}/music/`, formData),

    getAllComments: () => myAPI.get(`${API_BASE}/comments`),
    deleteComment: (comId) => myAPI.delete(`${API_BASE}/comments/${comId}`),
    addComment: (formData) => myAPI.post(`${API_BASE}/comments/`, formData),
};